<agpr-dialog-container
    id="sharedReportInviteDialog"
    [heading]="'Reports.sharedReportInviteDialog.heading'"
    [modal]="true"
    (close)="closeDialog()"
>
    <agpr-scroll-panel>
        <div class="agpr-sharedReportInviteDialog-content">
            <div class="agpr-sharedReportInviteDialog-form">
                <agpr-panel
                    [header]="'Reports.sharedReportInviteDialog.panel' | localize:{name: sharedReport.name}"
                    [toggleable]="false"
                    [contentPadding]="false"
                >
                    <div class="agpr-sharedReportInviteDialog-formInput">
                        <div class="agpr-inputGroup">
                            <label for="mailingLists.picker" class="agpr-sharedReportInviteDialog-inputLabel">
                                {{ 'Reports.sharedReportInviteDialog.report.mailingLists' | localize }}
                            </label>
                            <agpr-mailing-list-picker
                                [(ngModel)]="sharedReport.mailingListIds"
                                (ngModelChange)="checkRecipients()"
                            ></agpr-mailing-list-picker>
                        </div>
                        <div class="agpr-inputGroup">
                            <agpr-text-input-chips
                                [id]="'shareReport.recipientList'"
                                [splitOnPattern]="splitOnPattern"
                                [placeholder]="'Reports.sharedReportInviteDialog.report.recipients.placeholder'"
                                [chipValidations]="validateEmails"
                                [(ngModel)]="sharedReport.recipientList"
                                (ngModelChange)="checkRecipients()"
                                [header]="'Reports.sharedReportInviteDialog.report.recipients'"
                            ></agpr-text-input-chips>
                        </div>
                        <div class="agpr-inputGroup">
                            <agpr-text-input
                                [id]="'fromName'"
                                label="Reports.sharedReportInviteDialog.report.fromName"
                                [placeholder]="'Reports.sharedReportInviteDialog.report.fromName.placeholder'"
                                [bottomMargin]="false"
                                [(ngModel)]="sharedReport.fromName"
                            ></agpr-text-input>
                        </div>
                        <div class="agpr-inputGroup">
                            <agpr-text-input
                                [id]="'replyEmail'"
                                label="Reports.sharedReportInviteDialog.report.replyTo"
                                [placeholder]="'Reports.sharedReportInviteDialog.report.replyTo.placeholder'"
                                [bottomMargin]="false"
                                [(ngModel)]="sharedReport.replyTo"
                                (blur)="validateReplyTo()"
                            ></agpr-text-input>
                            <agpr-form-message *ngIf="invalidReplyTo">
                                {{ 'invalidEmailFormat' | localize }}
                            </agpr-form-message>
                        </div>
                        <div class="agpr-inputGroup">
                            <agpr-textarea-input
                                id="inviteMessage"
                                label="Reports.sharedReportInviteDialog.report.inviteMessage"
                                [(ngModel)]="sharedReport.inviteMessage"
                                (ngModelChange)="checkInputLength($event)"
                                [placeholder]="'Reports.sharedReportInviteDialog.report.inviteMessage.placeholder'"
                                [maxLength]="maxInputLength"
                            ></agpr-textarea-input>
                        </div>
                        <agpr-form-message *ngIf="recipientsEmpty">
                            {{ 'Reports.sharedReportInviteDialog.report.recipients.validation' | localize }}
                        </agpr-form-message>
                        <agpr-form-message *ngIf="inputLengthExceeding">
                            {{ 'Reports.sharedReportInviteDialog.report.inviteMessage.maxLength' | localize }}
                        </agpr-form-message>
                    </div>
                </agpr-panel>
            </div>
        </div>
    </agpr-scroll-panel>
    <ng-template #footerLeft>
        <agpr-button
            *ngIf="!canSkip"
            label="Core.button.cancel"
            id="sharedReportInviteDialog.cancelButton"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            *ngIf="canSkip"
            id="sharedReportInviteDialog.skip"
            label="Reports.sharedReportInviteDialog.skip"
            (click)="cancel()"
        ></agpr-button>
        <agpr-button
            id="sharedReportInviteDialog.actionButton"
            label="Reports.sharedReportInviteDialog.send"
            [style]="buttonType.primary"
            [loading]="shareLoading"
            (click)="shareReport()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
